import { TOLERANCIA_CENTAVO_CALIBRACAO } from '@fiodecobre/shared';

const cent = (n: number) => Math.round((Number(n) || 0) * 100) / 100;

/**
 * Quando o total desfaz o centavo da calibracao e as linhas sobram ate 5 centavos, qual linha de Pix
 * JA RECEBIDO deve baixar pro que de fato caiu? — PURA.
 *
 * A linha COBERTA (`dividirLinhaPorPixRecebido`) guarda o valor DECLARADO, e o refit nao toca linha
 * fixa ([DA-626]). Normalmente declarado == recebido e nada sobra. Mas se o pedido foi recalibrado
 * DEPOIS do Pix cair (ORC-008624, 05/10/2026: Pix de 53,00 vinculado, pedido reenviado ao caixa e
 * subido pra 53,01), a linha fixa afirma 53,01 que o banco nunca recebeu, o total desfaz pra 53,00
 * e a trava de gravacao ([DA-531], igualdade exata) recusa a venda pela sobra de 1 centavo.
 *
 * Baixa a linha so ate o RECEBIDO, nunca abaixo — o que entrou na conta e' o piso ([DA-585]).
 * Devolve `null` quando nao ha o que baixar; ai o chamador segue com o refit de sempre.
 *
 * Mora no web (e nao no shared) so pra a correcao subir sem reiniciar o servidor; o backend nao usa.
 */
export function baixarLinhaPixAoRecebido(
  linhas: Array<{ id: string; valor: number; recebido: number | null }>,
  sobra: number,
  tolerancia: number = TOLERANCIA_CENTAVO_CALIBRACAO,
): { id: string; valor: number } | null {
  const s = cent(sobra);
  if (s <= 0.005 || s > tolerancia) return null;
  const alvo = linhas.find((l) => l.recebido != null && cent(l.valor) - cent(l.recebido) > 0.005);
  if (!alvo) return null;
  return { id: alvo.id, valor: Math.max(cent(alvo.recebido!), cent(alvo.valor - s)) };
}
